<template src="./dashboard.html"></template>
<style src="./dashboard.scss" lang="scss"></style>

<script>
	import axios from 'axios';
	import * as contentful from 'contentful';
	import marked from 'marked';
	import anime from 'animejs';
	import Gate from './gate/gate';

	export default {
		components: {
			gate: Gate
		},
		data() {
			return {
				intro: null,
				gate_active: true
			}
		},
		mounted() {
			const content_client = contentful.createClient({
                space: process.env.SPACE_ID,
                accessToken: process.env.CMS_TOKEN
            });

			content_client.getEntries({
                content_type: 'dashboard_hero'
            }).then((response) => {
				this.intro = response.items[0].fields;
				Object.assign(this.intro.intro_module, this.intro.intro_module.fields);
            }).catch(console.error);

		},
		methods: {
			markdown(string) {
				return marked(string);
			},
			collapse_toggle(module_number) {
				let target = document.querySelector('.materials_list[data-module="' + module_number + '"]');
				let target_height = target.getBoundingClientRect().height + 48;

				if (this.collapsed['module_' + module_number]) {
					this.collapsed['module_' + module_number] = false;
					anime({
						targets: '.materials_container[data-module="' + module_number + '"]',
						height: [target_height, '48px'],
						easing: 'easeOutCubic',
						duration: 300
					});
				} else {
					this.collapsed['module_' + module_number] = true;
					anime({
						targets: '.materials_container[data-module="' + module_number + '"]',
						height: ['48px', target_height],
						easing: 'easeOutCubic',
						duration: 300
					});
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// dashboard.vue?d27ac77a